import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selecticon",
  "use": "icon-selecticon-usage",
  "viewBox": "0 0 1124 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1124 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-selecticon\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 651.462355l313.758132-175.544309 152.139884 275.0155c0 0 230.158871-544.185453 631.960785-750.933545 0 0-48.119333 300.375324 25.675929 390.098112 0 0-275.337958 83.872476-638.12879 633.901888L0 651.462355 0 651.462355zM0 651.462355\" p-id=\"6779\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol